module.exports = __webpack_public_path__ + "img/08.965e4683.png";